const { default: initMaskInputs } = require("./input-masks");
const { default: selectCategoryPosts } = require("./selectCateroryPosts");
const { initValideForms } = require("./validesForms");

require("./select3");
require("./cart/ajax/carrinho");
// require("./selectByNavigation");
require("./faq");
require("./cart/cart");
require("./slick2");
require("./modal-v2");
require('./modal-center-abandono');
require('./menu-map-site');
require('./menu-map-site-b2b');
require("./cookieconsent");
require("./carousel");
require("./addAdditionalPlan");
require('./nav-mobile')

initMaskInputs();
initValideForms();
selectCategoryPosts();
